export const CWID_PREFIX = "menu-item";
